import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { KeyValue } from "../models/common";
import { Result } from "../models/common/resultResponse";
import { ISystemApplicationApi } from "./base/systemApplicationApi";

const baseRoute: string = "SystemApplication";

export class SystemApplicationApi extends ISystemApplicationApi {
	getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`);
	}
}
